export async function promisePool<T>(tasks: Array<() => Promise<T>>, concurrency: number): Promise<Array<PromiseSettledResult<T>>> {
	const results: Array<PromiseSettledResult<T>> = []
	const executing = new Set<Promise<void>>()

	const run = async (task: () => Promise<T>) => {
		try {
			const value = await task()
			results.push({ status: 'fulfilled', value } as PromiseFulfilledResult<T>)
		} catch (reason) {
			results.push({ status: 'rejected', reason } as PromiseRejectedResult)
		}
	}

	let i = 0

	while (i < tasks.length) {
		while (executing.size < concurrency && i < tasks.length) {
			const task = run(tasks[i++]).finally(() => executing.delete(task))
			executing.add(task)
		}

		if (executing.size >= concurrency) {
			await Promise.race(executing)
		}
	}

	await Promise.allSettled(Array.from(executing))

	return results
}
